import { defineMessages } from "react-intl"

export const pricingContainerMessages = defineMessages({
	headline: {
		defaultMessage: "Pricing",
		id: "vehicleDetails.overview.pricing.headline",
	},
})
